export enum MedComplianceCode {
  Unshipped = 'EPREP_MED_UNSHIPPED',
  OrderProcessing = 'EPREP_MED_ORDER_PROCESSING'
}
